/* eslint-disable no-redeclare */
/* eslint-disable import/no-anonymous-default-export */
/*
    Customer Dashboard Reducer
    
*/
import _ from "lodash";
import moment from "moment";
import {
  GET_TRENDS_DATA,
  GET_TRENDS_DATA_FAILURE,
  GET_TRENDS_DATA_SUCCESS,
  GET_CUSTOMER_LIST_FOR_TRENDS,
  GET_CUSTOMER_LIST_FOR_TRENDS_FAILURE,
  GET_CUSTOMER_LIST_FOR_TRENDS_SUCCESS,
  SELECT_TRENDS_CUSTOMER,
  SET_CURRENT_CUSTOMER_DOMAINS,
  CLEAR_DOMAIN_LIST,
} from "../actions/types";
// initial state
const INIT_STATE = {
  domainList: [],
  trendPayload: null,
  dashboardData: [],
  filterDomains: [],
  filterModel: {
    type: "hour",
    text: "Last 12 hours",
    value: 12,
  },
  profilesStats: {
    new: 0,
    revisits: 0,
    updates: 0,
  },
  domainStats: [],
  browserStats: [],
  opPresent: false,
  mpPresent: false,
  reportType: null,
  filterDays: 0,
  loading: false,
  selectedCustomer: null,
  customers: [],
  noDataStatus: false,
  trendSeries: [],
  trendDays: [],
  group1: {
    profileData: { Daywise: [], aggregatedData: [] },
    cmpData: { Daywise: [], aggregatedData: [] },
  },
  group2: {
    profileData: { Daywise: [], aggregatedData: [] },
    cmpData: { Daywise: [], aggregatedData: [] },
  },
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SELECT_TRENDS_CUSTOMER:
      let selected = state.customers.filter(
        (customer) => customer.id === action.payload.id
      );
      var domains = [];
      // if the customer is found in the customer list
      if (selected[0]) {
        selected[0].domains.forEach((element) => {
          var domain = { value: element.name, label: element.name };
          domains.push(domain);
        });
      }
      return {
        ...state,
        selectedCustomer: action.payload,
        domainList: domains,
        noDataStatus: false,
      };
    case SET_CURRENT_CUSTOMER_DOMAINS:
      var domains = [];
      // if the customer is found in the customer list
      if (action.payload) {
        action.payload.forEach((element) => {
          var domain = { value: element.domain, label: element.domain };
          domains.push(domain);
        });
      }
      return {
        ...state,

        domainList: domains,
      };
    case GET_CUSTOMER_LIST_FOR_TRENDS:
      return { ...state };
    case GET_CUSTOMER_LIST_FOR_TRENDS_SUCCESS:
      return { ...state, customers: action.payload.data };
    case GET_CUSTOMER_LIST_FOR_TRENDS_FAILURE:
      return { ...state };
    // Get customer dashboard data from server.
    case GET_TRENDS_DATA:
      return {
        ...state,
        trendPayload: action.payload.trendsObject,
        dates: {
          startDate: moment()
            .subtract(action.payload.filter, "days")
            .format("YYYY-MM-DD"),
          endDate: moment().format("YYYY-MM-DD"),
        },

        loading: true,
        noDataStatus: false,
      };
    // On Success...
    case GET_TRENDS_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        group1: action.payload.group1,
        group2: action.payload.group2,
      };
    // On Failure, show error message.
    case GET_TRENDS_DATA_FAILURE:
      return { ...state, loading: false, noDataStatus: true };
    case CLEAR_DOMAIN_LIST:
      return {
        ...state,
        loading: false,
        domainList: [],
      };

    default:
      return { ...state, loading: false };
  }
};
